/**
 * Expose `JSON.parse` method or fallback if not
 * exists on `window`
 */

module.exports = 'undefined' === typeof JSON
  ? require('json-fallback').parse
  : JSON.parse;



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/lib/json-parse.js
// module id = 320
// module chunks = 0